import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import DesktopRibbon1 from '../assets/common/desktop-ribbon-1.jpg';
import DesktopRibbon2 from '../assets/common/desktop-ribbon-2.jpg';
import DesktopRibbon3 from '../assets/common/desktop-ribbon-3.jpg';
import MobileRibbon1 from '../assets/common/mobile-ribbon-1.jpg';
import MobileRibbon2 from '../assets/common/mobile-ribbon-2.jpg';
import MobileRibbon3 from '../assets/common/mobile-ribbon-3.jpg';
import MobileRibbon4 from '../assets/common/mobile-ribbon-4.jpg';
import projects1 from '../assets/projects/projects-01.jpg'
import projects2 from '../assets/projects/projects-02.jpg'
import projects3 from '../assets/projects/projects-03.jpg'
const DesktopRibbon = [DesktopRibbon1, DesktopRibbon2, DesktopRibbon3];
const MobileRibbon = [MobileRibbon1, MobileRibbon2, MobileRibbon3, MobileRibbon4];

const t1 =`We ensure top educational international standards through our partnerships.`
const t2 =`Combining academics, sports, and activities to prepare students for success.`
const t3 =`Introducing community-driven concepts like "Mum’s Hub" to enhance educational experience.`


const Projects = () => {
  useEffect(() => {AOS.init({duration: 1000, easing: 'ease-in-out',once: true,});}, []);

  return (
    <div className="w-full px-0 overflow-hidden relative">

    {/* Desktop Hero Section */}
    <div className="hidden md:block slider-container" data-aos="fade-up">
    <div className="slider">{Array.from({ length: 200 }).map((_, index) => (<img src={DesktopRibbon[index % DesktopRibbon.length]} alt={`Hero ${index + 1}`} key={index} className="hero-image" />))}</div>  
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center font-tenor text-white">
    <div className="space-y-4 text-base">
      <p className="text-3xl uppercase font-bold">Our Commitment to Excellence</p> 
      <div><span className="font-bold">Academic Rigor: </span>{t1}</div>
      <div><span className="font-bold">Holistic Development: </span>{t2}</div>
      <div><span className="font-bold">Innovation: </span>{t3}</div>
    </div></div></div>

    {/* Mobile Hero Section */}
    <div className="block md:hidden slider-container" data-aos="fade-up">
    <div className="slider-mobile">{Array.from({ length: 200 }).map((_, index) => (<img src={MobileRibbon[index % MobileRibbon.length]} alt={`Hero ${index + 1}`} key={index} className="hero-image" />))}</div>
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full p-6 font-tenor text-white text-center">
    <div className="space-y-4 text-[0.82rem] tracking-tighter">
    <p className="text-base uppercase font-bold">Our Commitment to Excellence</p>    
    <div className='px-2'><span className="font-bold">Academic Rigor: </span>{t1}</div>
    <div className='px-2'><span className="font-bold">Holistic Development: </span>{t2}</div>
    <div className='px-2'><span className="font-bold">Innovation: </span>{t3}</div>
    </div></div></div>

  
  <p className='px-8 md:px-12 pt-6 pb-2 md:pb-0 font-bold uppercase text-green text-2xl font-tenor' data-aos="fade-up-right">our project</p>


  <div className="px-8 md:px-12 md:pb-8 flex flex-col md:flex-row w-full font-tenor text-blue text-sm items-center">
  <div className="md:pr-16 w-full md:w-[60%]" data-aos="fade-up">
    <p className='font-bold text-lg mb-[0.1rem]'>Uppingham Cairo At New Giza </p>
    <p className='mb-2'>(Operating Since September 2024)</p>
    <p className='mb-2'>Uppingham Cairo brings the prestigious legacy of Uppingham School, founded in 1584, to Egypt.</p>
    <ul className="list-disc pl-5 space-y-2 marker:text-green" data-aos="fade-right">
    <li className='pl-2'><strong>Location: </strong>New Giza</li>
    <li className='pl-2'><strong>Curriculum: </strong>International Baccalaureate (IB), IGCSE, and A-Level</li>
    <li className='pl-2'><strong>Programs: </strong>Designed to nurture intellectual curiosity, creativity, and leadership in students.</li></ul></div>
    <div className="mt-4 md:mt-0 w-full md:w-[40%] overflow-hidden"><img src={projects1} alt='' className='w-full transition-transform duration-500 ease-in-out hover:scale-105' data-aos="fade-left"/></div></div>

  
  {/* DESKTOP ONLY */}
  <div className="hidden md:flex px-12 md:pb-8  flex-row w-full font-tenor text-blue text-sm items-center">
  <div className="mt-0 w-[40%] overflow-hidden"><img src={projects2} alt='' className='w-full transition-transform duration-500 ease-in-out hover:scale-105' data-aos="fade-right"/></div>
  <div className="pl-16 w-[60%]" data-aos="fade-up">
  <p className='font-bold text-lg mb-[0.1rem]'>Moon Hall Cairo Learning Centre at New Giza</p>
  <p className='mb-2'>(Opening April 2025)</p>
    <p className='mb-2'>In collaboration with Moon Hall School, Reigate, we are proud to introduce Egypt’s first Special Needs Learning Centre, catering to students with dyslexia and learning difficulties.</p>
    <ul className="list-disc pl-5 space-y-2 marker:text-green" data-aos="fade-right">
    <li className='pl-2'><strong>Location: </strong>New Giza</li>
    <li className='pl-2'><strong>Focus: </strong>Helping students thrive academically while nurturing their intellectual and creative potential.</li></ul></div></div>

  {/* MOBILE ONLY */}
  <hr className="md:hidden border-green mx-8 my-6" />
  <div className="flex md:hidden px-8 flex-col w-full font-tenor text-blue text-sm items-center">
  <div className="w-full" data-aos="fade-up">
  <p className='font-bold text-lg mb-[0.1rem]'>Moon Hall Cairo Learning Centre at New Giza</p>
  <p className='mb-2'>(Opening April 2025)</p>
    <p className='mb-2'>In collaboration with Moon Hall School, Reigate, we are proud to introduce Egypt’s first Special Needs Learning Centre, catering to students with dyslexia and learning difficulties.</p>
    <ul className="list-disc pl-5 space-y-2 marker:text-green" data-aos="fade-right">
    <li className='pl-2'><strong>Location: </strong>New Giza</li>
    <li className='pl-2'><strong>Focus: </strong>Helping students thrive academically while nurturing their intellectual and creative potential.</li></ul></div>
    <div className="mt-4 w-full overflow-hidden"><img src={projects2} alt='' className='w-full transition-transform duration-500 ease-in-out hover:scale-105' data-aos="fade-left"/></div></div>

  <hr className="md:hidden border-green mx-8 my-6" />
  <div className="px-8 md:px-12 md:pb-6 flex flex-col md:flex-row w-full font-tenor text-blue text-sm items-center">
  <div className="md:pr-16 w-full md:w-[60%]" data-aos="fade-up">
  <p className='font-bold text-lg mb-[0.1rem]er'>King’s School of Canterbury Cairo</p>
  <p className='mb-2'>(Opening September 2027)</p>
    <p className='mb-2'>A partnership with the oldest school in the world, King’s School of Canterbury, brings its unparalleled legacy of academic and cultural excellence to Egypt.</p>
    <ul className="list-disc pl-5 space-y-2 marker:text-green" data-aos="fade-right">
    <li className='pl-2'><strong>Programs: </strong>Offering a premium British curriculum that fosters innovation and academic achievement.</li></ul></div>
    <div className="mt-4 md:mt-0 w-full md:w-[40%] overflow-hidden"><img src={projects3} alt='' className='w-full transition-transform duration-500 ease-in-out hover:scale-105' data-aos="fade-left"/></div></div>
<br className='mb-4'/>
      
    </div>
  );
};

export default Projects;


